import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledSearchPage = styled('div')`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.greyBackground};

  .nothing {
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 30px;
  }

  .farm-name {
    overflow: hidden;
  }

  .farm-card .rect-angle-wrap {
    display: none;
  }

  .section {
    margin-bottom: 40px;
    margin-top: 40px;

    .pagination {
      display: flex;
      justify-content: center;
      padding: 40px;

      .ant-pagination {
        .ant-pagination-item {
          justify-content: center;
        }
      }
    }

    .title {
      text-align: left;
      font-weight: 300;

      h1 {
        font-family: ${(props) => props.theme.fontText};
      }
    }
  }

  .grid-view {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0, 261px));
    gap: 32px;
    justify-content: center;
    justify-items: center;
  }

  .section.products .grid-view {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .section.products .grid-view {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }
`;
